import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Spinner from '../Spinner'; // Import your Spinner component
import FormCard from './FormCard';
import $ from 'jquery';  // Import jQuery (if it's not already available)
import 'jquery-confirm'; 
import Modal from "react-modal";
import api from '../../api/axiosInstance';

const FormMastersCard = () => {
  const [inProgressForms, setInProgressForms] = useState([]);
  const [approvedForms, setApprovedForms] = useState([]);
  const [publishedForms, setPublishedForms] = useState([]);
  const [expiredForms, setExpiredForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formCategories, setFormCategories] = useState([]); 

  const [formTypes, setFormTypes] = useState([]);
  const [formSubCategories, setFormSubCategories] = useState([]);
  const [blocked, setBlocked] = useState(false);

  
 // Fetch Form Categories and Form Types
const fetchFormCategoriesAndTypes = async () => {
  try {
    const response = await api.get('/FormMaster/GetAllFormCategoriesAndSubCategories');
    if (response.data) {debugger;
      console.log(response.data);
      setFormCategories(response.data.formCategories || []);  // Ensure the default is an empty array
      setFormSubCategories(response.data.formSubCategories || []); // Ensure the default is an empty array
    } else {
      console.error("Error: Invalid data structure received from API.");
      setFormCategories([]);
      setFormTypes([]);
      setFormSubCategories([]);
    }
  } catch (error) {
    console.error('Error fetching form categories and types:', error);
    $.alert("Error fetching form categories and subcategories.");
  }
};


  // Define the fetchFormMasters function outside useEffect
const fetchFormMasters = async () => {
  try {
    const response = await api.get("/FormMaster");
    debugger;

    setInProgressForms(response.data.inProgressForms);
    setApprovedForms(response.data.approvedForms);

    const today = new Date().toISOString().split("T")[0];
             const published = response.data.publishedForms.filter(x => {
  const expiry = x.expiryDate?.split("T")[0];
  return (
     expiry === "0001-01-01" ||
    expiry > today  
  );
});
  const expiryDate = response.data.publishedForms.filter(x => {
  const expiry = x.expiryDate?.split("T")[0];
  return (
     expiry !== "0001-01-01" &&
    expiry < today  
  );
});

    setPublishedForms(published);
    setExpiredForms(expiryDate);
  } catch (error) {
    console.error("Error fetching form masters", error);
  }
   finally {
    setLoading(false);   // 🔥 MOST IMPORTANT LINE
  }
};



  // Calling fetchFormMasters once on component mount
useEffect(() => {
   fetchFormMasters();
   fetchFormCategoriesAndTypes();
}, []);

  // Handle deleting the form
// Inside FormMastersCard
const handleDelete = async (formId, category) => {
  setBlocked(true);

  try {
    await api.delete(
      `/FormMaster/DeleteFormMaster?id=${formId}`
    );

    // ✅ OPTIMIZED: Update local state directly based on category
    if (category === 'In-Progress') {
      setInProgressForms(prev => prev.filter(f => f.id !== formId));
    } else if (category === 'Approved') {
      setApprovedForms(prev => prev.filter(f => f.id !== formId));
    } else if (category === 'Published') {
      setPublishedForms(prev => prev.filter(f => f.id !== formId));
    } else if (category === 'Expired') {
      setExpiredForms(prev => prev.filter(f => f.id !== formId));
    }
    $.alert({ title: "Success", content: "Record deleted successfully", type: "green" });

  } catch (error) {
    console.error("Error deleting form", error);
    $.alert("Error deleting the form.");
  } finally {
    setBlocked(false);
  }
};
  // Handle activating the form
  const handleActivate = (formId) => {

    $.confirm({
      title: 'Confirm Activation',
      content: 'Do you really want to activate this Form Master?',
      type: 'blue',
      buttons: {
        confirm: {
          text: 'Yes',
          btnClass: 'btn-blue',
          action: function () {debugger;
                setBlocked(true);
            const loggedInUser = JSON.parse(localStorage.getItem('user')); // Parse the string to object
            const loggedInUserId = loggedInUser.id; // Now you can access the id

             // Modify the URL to pass 'recordGuid' and 'modifiedBy' as query parameters
          api.put(`/FormMaster/ActivateFormMaster?recordGuid=${formId}&modifiedBy=${loggedInUserId}`)
          .then(response => {
            $.alert({
              title: 'Success',
              content: response.data.message || "Form Master activated successfully",
              type: 'green'
            });
           
              // Refresh form masters after activation
              setLoading(true);
              fetchFormMasters(); // Refresh the data after activation
              setBlocked(false);
            })
            .catch((error) => {
              console.error("Error activating form master", error);
              $.alert({
                title: 'Error',
                content: 'Failed to activate the Form Master.',
                type: 'red'
              });
            });
          }
        },
        cancel: {
          text: 'No',
          btnClass: 'btn-default',
        }
      }
    });
  };
  const handleExpiryDate = (formId, expiryDate) => {debugger;
    if (!formId || !expiryDate) {
      $.alert("Form ID or Expiry Date is missing.");
      return;
    }
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    const loggedInUserId = loggedInUser.id;

    api.put(`/FormMaster/SetExpiryDate?recordGuid=${formId}&expiryDate=${expiryDate.toISOString()}&modifiedBy=${loggedInUserId}`)
      .then(response => {
        $.alert({
          title: 'Success',
          content: response.data.message || "Expiry Date saved successfully",
          type: 'green'
        });

        fetchFormMasters(); // Refresh the data after setting the expiry date
      })
      .catch((error) => {
        console.error("Error setting expiry date", error);
        $.alert({
          title: 'Error',
          content: 'Failed to set expiry date.',
          type: 'red'
        });
      });
  };
    // Handle saving the new form
   const handleSaveNewForm = async (formData) => {
    debugger;
  setBlocked(true);

  try {
    const finalData = {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      name: formData.name,
      description: "Some description here",
      createdByContactId: JSON.parse(localStorage.getItem('user')).id,
      createdByContactName: "John Doe",
      modifiedByContactId: JSON.parse(localStorage.getItem('user')).id,
      modifiedByContactName: "John Doe",
      formCategoryId: formData.formCategoryId,
      formCategoryName: "Some Category",
      formSubCategoryId: formData.formSubCategoryId,
      formSubCategoryName: "Some SubCategory",
      statusReasonValue: 1,
      statusReasonText: "Sample Status",
      formTypeValue: formData.formTypeValue,
      formTypeText: formData.formTypeText,
      forOneTimeUse: formData.forOneTimeUse,
      allowSubmitterToAddComment: true,
      allowReviewerToAddComment: true,
      allowOthersToAddComment: true,
      allowSubmitterToPrint: true,
      allowReviewerToPrint: true,
      allowOthersToPrint: true,
      allowSubmitterToAddAttachment: true,
      allowReviewerToAddAttachment: true,
      allowOthersToAddAttachment: true,
      allowSubmitterToSelectReviewer: true,
      approvedOn: new Date().toISOString(),
      createdOn: new Date().toISOString(),
      modifiedOn: new Date().toISOString(),
      expiryDate: new Date().toISOString(),
      publishedOn: new Date().toISOString(),
    };

  if(!finalData.formCategoryId)
{
alert("Please Select a valid Form Category ");
return;
}

if(!finalData.formSubCategoryId)
{
alert("Please Select a valid Form  SubCategory ");
return;
}


    // ⬇⬇ API CALL
    const response = await api.post(
      "/FormMaster/CreateFormMaster",
      finalData,
      { headers: { "Content-Type": "application/json" } }
    );

    $.alert({
      title: "Success",
      content: "Record saved successfully",
      type: "green",
    });

    debugger;
        setLoading(true);
    await fetchFormMasters();

  } catch (error) {
    console.error("Error saving new form:", error);
    $.alert("Error saving form.");
  }

  finally {
    setBlocked(false);   // 🔥 Always runs — success or fail
  }
};

 
const handleSetPublished =(formId)=>{debugger;


  $.confirm({
    title: 'Confirm Publish',
    content: 'Do you really want to Publish this Form Master?',
    type: 'blue',
    buttons: {
      confirm: {
        text: 'Yes',
        btnClass: 'btn-blue',
        action: function () {debugger;
          setBlocked(true);
          const loggedInUser = JSON.parse(localStorage.getItem('user')); // Parse the string to object
          const loggedInUserId = loggedInUser.id; // Now you can access the id

           // Modify the URL to pass 'recordGuid' and 'modifiedBy' as query parameters
        api.post(`/FormMaster/PublishFormMaster?recordGuid=${formId}&modifiedBy=${loggedInUserId}`)
        .then(response => {
             setBlocked(false);
          $.alert({
            title: 'Success',
            content: response.data.message || "Form Master published successfully",
            type: 'green'
          });
         
            // Refresh form masters after activation
           setLoading(true);
            fetchFormMasters(); // Refresh the data after activation
          // setLoading(false);
       
          })
          .catch((error) => {
            setBlocked(false);
            console.error("Error publishing form master", error);
            $.alert({
              title: 'Error',
              content: 'Failed to publish the Form Master.',
              type: 'red'
            });
          });
        }
      },
      cancel: {
        text: 'No',
        btnClass: 'btn-default',
      }
    }
  });
}

const copyFormMaster = (formId) => {
  $.confirm({
    title: 'Confirm Copy',
    content: 'Do you really want to copy this Form Master?',
    type: 'blue',
    buttons: {
      confirm: {
        text: 'Yes',
        btnClass: 'btn-blue',
        action: async function () {
          setBlocked(true);
          try {
            const loggedInUser = JSON.parse(localStorage.getItem('user'));
            const loggedInUserId = loggedInUser.id;

            setLoading(true); // start refreshing

            const response = await api.post(
              `/FormMaster/CopyFormMaster?recordGuid=${formId}&createdBy=${loggedInUserId}`
            );

            $.alert({
              title: "Success",
              content: response.data.message || "Form Master Copied Successfully",
              type: "green",
            });
          debugger;
            await fetchFormMasters();  // 🔥 refresh list // 🔥 stop spinner so UI updates
            setBlocked(false);
         
          } catch (error) {
            console.error("Error copying form master", error);
            $.alert({
              title: "Error",
              content: "Failed to copy the Form Master.",
              type: "red",
            });
        setBlocked(false)

          }
        }
      },
      cancel: {
        text: "No",
        btnClass: "btn-default",
      }
    }
  });
};


const [isModalOpen, setIsModalOpen] = useState(false);
const [newForm, setNewForm] = useState({
  name: "",
  formCategoryId: "",
  formSubCategoryId: "",
  formTypeValue: "121440000",
  forOneTimeUse: false,
  formTypeText:"Internal"
});


const handleInputChange = (e) => {
  debugger;
  const { id, value, type, checked } = e.target;

  // If checkbox
  if (type === "checkbox") {
    setNewForm((prev) => ({
      ...prev,
      [id]: checked
    }));
    return;
  }

  // If Form Type change (dropdown)
  if (id === "formTypeValue") {
    debugger;
    const text =
      e.target.options?.[e.target.selectedIndex]?.text || "";
     if(text==="External")
      {
        // uncheked the forone time 
        //hide the btn 
      setNewForm((prev) => ({
      ...prev,
        forOneTimeUse:false
    }));

      }

    setNewForm((prev) => ({
      ...prev,
      formTypeValue: value,
      formTypeText: text
    }));
     
    return;
  }

  // Other inputs
  setNewForm((prev) => ({
    ...prev,
    [id]: value
  }));
};



const openCreateFormModal = () => {
  setIsModalOpen(true);
};
const closeModal = () => {
  setIsModalOpen(false);
};
const handleSave = () => {
  debugger;
  handleSaveNewForm(newForm);
  closeModal();
   setNewForm({
      name: "",
      formCategoryId: "",
      formSubCategoryId: "",
      formTypeValue: "0",
      forOneTimeUse: false,
        formTypeText:""
    });
};

const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.2)", // light dark shade
  zIndex: 9998,
  cursor: "wait"  // cursor changes to loading
};

const overlayStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#222",
  padding: "30px 50px",
  borderRadius: "12px",
  zIndex: 9999,
  color: "#fff",
  fontSize: "22px",
  textAlign: "center",
  cursor: "wait" // cursor loading
};
  return (


    <div>
{blocked && (
  <>
    {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
    <div style={backdropStyle}></div>

    {/* CENTER BOX */}
    <div style={overlayStyle}>
      <div className="spinner-border" role="status"></div>
      <div>Please wait…</div>
    </div>
  </>
)}

      {loading ? (
        <Spinner />
      ) : (
        <>
          <FormCard
            title="In-Progress Forms"
            forms={inProgressForms}
            handleDelete={(formId) => handleDelete(formId, 'In-Progress')}
            handleActivate={handleActivate} // Pass handleActivate to FormCard
            handleExpiryDate={handleExpiryDate}
            handleSetPublished={handleSetPublished}
            copyFormMaster={copyFormMaster}
            openCreateFormModal={openCreateFormModal}
          />
          <FormCard
            title="Approved Forms"
            forms={approvedForms}
            handleDelete={(formId) => handleDelete(formId, 'Approved')}
            handleActivate={handleActivate} // Pass handleActivate to FormCard
            handleExpiryDate={handleExpiryDate}
            handleSetPublished={handleSetPublished}
            copyFormMaster={copyFormMaster}
          />
          <FormCard
            title="Published Forms"
            forms={publishedForms}
            handleDelete={(formId) => handleDelete(formId, 'Published')}
            handleActivate={handleActivate} // Pass handleActivate to FormCard
            handleExpiryDate={handleExpiryDate}
            handleSetPublished={handleSetPublished}
            copyFormMaster={copyFormMaster}
          />
          <FormCard
            title="Expired Forms"
            forms={expiredForms}
            handleDelete={(formId) => handleDelete(formId, 'Expired')}
            handleActivate={handleActivate} // Pass handleActivate to FormCard
            handleExpiryDate={handleExpiryDate}
            handleSetPublished={handleSetPublished}
            copyFormMaster={copyFormMaster}
          />

 <Modal
  isOpen={isModalOpen}
  onRequestClose={closeModal}
  ariaHideApp={false}
  style={{
    content: { width: "400px", margin: "auto", borderRadius: "10px"}
  }}
>
  <h2>Create New Form</h2>

  <div>
    <label>Name:</label>
    <input
      type="text"
      id="name"
      className="form-control"
      value={newForm.name}
      onChange={handleInputChange}
    />
  </div>

  <div>
    <label>Form Category:</label>
    <select
      id="formCategoryId"
      className="form-control"
      value={newForm.formCategoryId}
      onChange={handleInputChange}
    >
      <option value="">-- Select --</option>

      {formCategories.map(cat => (
        <option key={cat.id} value={cat.id}>{cat.name}</option>
      ))}
    </select>
  </div>
  <div>
    <label>Form Sub-Category:</label>
    <select
      id="formSubCategoryId"
      className="form-control"
      value={newForm.formSubCategoryId}
      onChange={handleInputChange}
    >
      <option value="">-- Select --</option>

      {formSubCategories
        .filter(s => s.formCategoryId === newForm.formCategoryId)
        .map(sub => (
          <option key={sub.id} value={sub.id}>{sub.name}</option>
        ))}
    </select>
  </div>

  <div>
    <label>Form Type:</label>
    <select
      id="formTypeValue"
      className="form-control"
      value={newForm.formTypeValue}
      onChange={handleInputChange}
    >
      <option value="121440000">Internal</option>
      <option value="121440001">External</option> 
    </select>
  </div>
{newForm.formTypeText!=="External" &&(
  <div id="foronetype">
    <label>For One Time Use?</label>
    <input
      type="checkbox"
      id="forOneTimeUse"
      checked={newForm.forOneTimeUse}
      onChange={handleInputChange}
    />
  </div>
)}

  <div style={{ marginTop: "15px" }}>
    <button className="btn btn-secondary" onClick={closeModal}>
      Cancel
    </button>
    <button className="btn btn-primary" onClick={handleSave} style={{ marginLeft: "10px" }}>
      Save
    </button>
  </div>
</Modal>

        </>
      )}
    </div>
  );
};

export default FormMastersCard;
